import { VERSION_DEFAULT_SORT } from "~/constants/version";

export default () => ({
  versions: null,
  agencies: {},
  loading: false,
  instanceId: null,
  versionsPerAgentEvolutionStats: { labels: [], datasets: [{ label: [], data: [] }] },
  page: 0,
  sortBy: VERSION_DEFAULT_SORT.sortBy,
  orderBy: VERSION_DEFAULT_SORT.orderBy,
  search: "",
});
